var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.582,
    height: 22.474,
    viewBox: "0 0 25.582 22.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 25.582,
    height: 22.474,
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(-1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(1 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M22.183,8.959A4.874,4.874,0,0,0,19.521,0,4.841,4.841,0,0,0,15.2,2.609a4.824,4.824,0,0,0-2.371-.633,4.878,4.878,0,0,0-2.45.658A4.871,4.871,0,1,0,3.4,8.958,6.018,6.018,0,0,0,0,14.386v3.241a1.986,1.986,0,0,0,.685,1.449c1.08,1,3.293,1.4,5.374,1.4.316,0,.606,0,.922-.027a2.555,2.555,0,0,0,1.106,1.08,10.515,10.515,0,0,0,4.768.949,10.305,10.305,0,0,0,4.821-1A2.282,2.282,0,0,0,18.7,20.419c.29.026.607.026.922.026,2.055,0,4.241-.4,5.3-1.4a1.86,1.86,0,0,0,.658-1.449V14.386a6.14,6.14,0,0,0-3.4-5.427Zm-2.661-7.64a3.557,3.557,0,0,1,0,7.114,3.514,3.514,0,0,1-1.924-.58,4.136,4.136,0,0,0,.1-1A4.947,4.947,0,0,0,16.281,3.4a3.541,3.541,0,0,1,3.241-2.082ZM16.387,6.851A3.557,3.557,0,1,1,12.83,3.294a3.575,3.575,0,0,1,3.557,3.557M2.5,4.875a3.554,3.554,0,0,1,6.823-1.4,4.877,4.877,0,0,0-1.37,3.372,4,4,0,0,0,.1.975,3.516,3.516,0,0,1-2,.606A3.576,3.576,0,0,1,2.5,4.875ZM6.77,16.388v2.74c-2.239.1-4.4-.316-5.19-1.027a.611.611,0,0,1-.264-.474V14.386A4.742,4.742,0,0,1,5.427,9.7a5.128,5.128,0,0,0,.633.053A5.124,5.124,0,0,0,6.693,9.7a4.768,4.768,0,0,1,2.924,1.555A6.132,6.132,0,0,0,6.77,16.388Zm10.776,3.241c0,.237-.184.474-.58.711-1.818,1.08-6.376,1.08-8.246.027-.422-.237-.632-.5-.632-.738V16.388A4.726,4.726,0,0,1,12.25,11.7a4.268,4.268,0,0,0,.58.026c.184,0,.369-.026.553-.026a4.726,4.726,0,0,1,4.163,4.69Zm6.692-2A.645.645,0,0,1,24,18.1c-.764.711-2.924,1.133-5.137,1.027v-2.74a6,6,0,0,0-2.872-5.137,4.616,4.616,0,0,1,2.9-1.528,5.124,5.124,0,0,0,.633.053,5.128,5.128,0,0,0,.633-.053,4.718,4.718,0,0,1,4.083,4.69Z",
    transform: "translate(0 0)",
    fill: "#065683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariance);
export default __webpack_public_path__ + "static/media/variance.e7db8281f174760e0b066f28f5e8cac4.svg";
export { ForwardRef as ReactComponent };